import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./style";

export const Footer = () => {
  return (
    <div css={styles.container}>
      <div css={styles.wwLogo}>
        <StaticImage
          src={"../../../images/img_whowatch_white.png"}
          alt={"ロゴ"}
          width={112}
          height={32}
        />
      </div>
      <div css={styles.links}>
        <div css={styles.downloadLinks}>
          <div css={styles.appIcon}>
            <StaticImage
              src={"../../../images/icon_app.png"}
              alt={"ふわっちアプリ"}
              width={56}
              height={56}
            />
          </div>
          <a
            css={styles.appstore}
            href="https://apps.apple.com/app/id1106217401"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StaticImage
              src={"../../../images/appstore.png"}
              alt={"App Store"}
              width={152}
              height={56}
            />
          </a>
          <a
            css={styles.googleplay}
            href="https://play.google.com/store/apps/details?id=jp.jig.product.whowatch.viewer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <StaticImage
              src={"../../../images/googleplay.png"}
              alt={"Google Play"}
              width={189}
              height={56}
            />
          </a>
        </div>
        <a
          css={styles.twitter}
          href="https://twitter.com/whowatch"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StaticImage
            src={"../../../images/icon_twitter_x.png"}
            alt={"Twitter"}
            width={32}
            height={32}
          />
        </a>
      </div>
    </div>
  );
};
